// Copied from: https://github.com/schoolfunrun/constructicon/blob/master/source/components/button-share/index.js
import React from 'react'
import PropTypes from 'prop-types'
import Button from 'constructicon/button'
import Icon from '../Icon'
import openShareDialog from './openShareDialog'

const ButtonShare = ({
  children,
  share,
  type,
  url,
  title,
  hashtags,
  image,
  onClick,
  ...props
}) => (
  <Button
    background={type}
    tag={share ? 'button' : 'a'}
    onClick={() => {
      if (share) {
        openShareDialog({ type, url, title, hashtags, image, onClick })
      }
    }}
    aria-label={`${share ? 'Share' : 'View'} on ${labelUpdate(type)}`}
    {...props}
  >
    <Icon name={type} alt={labelUpdate(type)} />
    {children}
  </Button>
)

const labelUpdate = (type) => {
  if (type === 'twitter') {
    return 'x'
  }

  return type
}

ButtonShare.propTypes = {
  /**
   * The social network / share target
   */
  type: PropTypes.oneOf([
    'facebook',
    'fitbit',
    'google',
    'instagram',
    'linkedin',
    'mail',
    'mapmyfitness',
    'messenger',
    'nextdoor',
    'pinterest',
    'reddit',
    'slack',
    'sms',
    'strava',
    'twitter',
    'vimeo',
    'whatsapp',
    'youtube'
  ]).isRequired,

  /**
   * Makes the button a share button (only available for twitter, facebook, linkedin, pinterest & mail)
   */
  share: PropTypes.bool,

  /**
   * Hashtags to be added to a twitter share
   */
  hashtags: PropTypes.string,

  /**
   * The text for a twitter, linkedin or pinterest share. Also the email subject for mail share
   */
  title: PropTypes.string
}

ButtonShare.defaultProps = {
  spacing: 0.5,
  effect: 'grow',
  radius: 'large',
  target: '_blank'
}

export default ButtonShare
